/**
 * Centralized access to environment variables.
 * Everything the web app reads from `import.meta.env` flows through here so we
 * can validate it once and fail loudly on misconfiguration.
 *
 * Default base URL is empty string, which means callers issue requests at
 * paths like `/api/v1/...` and Vite's dev-server proxy (vite.config.ts)
 * forwards `/api` to the backend on :8000. In prod set
 * VITE_API_BASE_URL=https://api.your-domain to point at a separate origin.
 */
const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "");

// Dark-launch flag for progressive (SSE) Ask Meridian streaming. Off unless
// VITE_ASK_STREAMING is "1"/"true"/"yes". When off, the chat uses the
// one-shot POST /ask. See docs/specs/ASK_STREAMING.md.
const ASK_STREAMING = ["1", "true", "yes"].includes(
  String(import.meta.env.VITE_ASK_STREAMING ?? "").toLowerCase(),
);

// Dark-launch flag for durable Ask: enqueue a background job and poll instead
// of holding a request open, so the answer survives navigating away. Off
// unless VITE_ASK_DURABLE is "1"/"true"/"yes". Pairs with the backend's
// API_BACKGROUND_JOBS_ENABLED. See docs/specs/BACKGROUND_JOBS.md.
const ASK_DURABLE = ["1", "true", "yes"].includes(
  String(import.meta.env.VITE_ASK_DURABLE ?? "").toLowerCase(),
);

export const env = {
  apiBaseUrl: API_BASE_URL,
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
  askStreaming: ASK_STREAMING,
  askDurable: ASK_DURABLE,
} as const;
